export default __webpack_public_path__ + "static/media/tractor_semi_functional.319eab29.svg";